// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__tz-qC","emails":"CreateEditClinics_emails__2POtR","emailTagLabel":"CreateEditClinics_emailTagLabel__1bHeu"};